import React,{ Component } from 'react';
import ReactDOM from 'react-dom';
import img1 from '../../assets/p35.jpg'
import img2 from '../../assets/p34.jpg'
import img3 from '../../assets/p32.jpg'
import img4 from '../../assets/p33.jpg'

import InfiniteCarousel from 'react-leaf-carousel';

class CardSlide extends React.Component{
      render(){
      return(
  <div>
  <InfiniteCarousel
    breakpoints={[
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ]}
    dots={true}
    showSides={true}
    sidesOpacity={.5}
    sideSize={.1}
    slidesToScroll={1} //number of images per slide
    slidesToShow={4}//number of images to show
    scrollOnDevice={true}
  >
    <div>
      <img
        alt=''
        src={img1}
      />
    </div>
    <div>
      <img
        alt=''
        src={img2}
      />
    </div>
    <div>
      <img
        alt=''
        src={img3}
      />
    </div>
    <div>
      <img
        alt=''
        src={img4}
      />
    </div>
    <div>
      <img
        alt=''
        src={img1}
      />
    </div>
    <div>
      <img
        alt=''
        src={img2}
      />
    </div>
    <div>
      <img
        alt=''
        src={img3}
      />
    </div>
    <div>
      <img
        alt=''
        src={img4}
      />
      </div>
  </InfiniteCarousel>
  </div>
      );
}
}

export default CardSlide